import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '見積もりは無料ですか？',
      answer: 'はい、お見積もりは無料で承っております。現地調査も含めて費用は一切かかりませんので、お気軽にご相談ください。詳細な図面作成や特殊な調査が必要な場合のみ、事前にご相談させていただきます。'
    },
    {
      question: '工事期間はどのくらいかかりますか？',
      answer: '工事の規模や内容によって異なりますが、一般的な住宅外構工事で1〜2週間、道路舗装工事で数日〜1週間程度です。詳細な工期については、現地調査後にお見積もりと合わせてご提示いたします。天候等により工期が延長する場合もございます。'
    },
    {
      question: '岡山市・倉敷市以外でも工事は可能ですか？',
      answer: '岡山市・倉敷市を中心としておりますが、岡山県内であれば対応可能です。ただし、遠方の場合は出張費等が発生する場合がございます。まずはお気軽にご相談ください。工事内容や規模によっても対応範囲が変わる場合があります。'
    },
    {
      question: '工事中の騒音や振動は大丈夫ですか？',
      answer: '工事中はどうしても騒音や振動が発生いたします。事前に近隣の皆様へご挨拶に伺い、工事内容や期間をご説明いたします。また、作業時間は平日の8時〜17時を基本とし、土日祝日の作業は原則として行いません。'
    },
    {
      question: 'アフターサービスはありますか？',
      answer: '工事完了後も責任を持ってアフターサービスを提供いたします。工事内容に応じて保証期間を設けており、期間内であれば無償で対応いたします。また、定期点検のご案内もさせていただいております。'
    },
    {
      question: '支払い方法はどのようになりますか？',
      answer: '工事代金のお支払いは、現金振込、銀行振込に対応しております。工事規模に応じて、着手金と完成時の分割払いも可能です。詳細な支払い条件については、契約時にご相談させていただきます。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>よくある質問</strong>
          </h2>
          <p className="text-xl text-gray-600">
            お客様からよくいただくご質問をまとめました。
            その他ご不明な点がございましたら、お気軽にお問い合わせください。
          </p>
        </div>

        <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg" itemScope itemType="https://schema.org/Question">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="font-semibold text-gray-900 pr-4" itemProp="name">
                  {faq.question}
                </h3>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-blue-600 text-xl flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4" itemScope itemType="https://schema.org/Answer">
                  <div className="text-gray-600 leading-relaxed" itemProp="text">
                    {faq.answer}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-blue-50 rounded-lg p-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">その他のご質問がございましたら</h3>
            <p className="text-gray-600 mb-6">
              お電話またはお問い合わせフォームより、お気軽にご相談ください。
              専門スタッフが丁寧にお答えいたします。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center border-2 border-blue-600 text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                お問い合わせフォーム
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}